import { useStore } from '@nanostores/react';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export const ZendeskOAuthRedirectHandler = () => {
  const org = useStore($org);
  const effectRunRef = useRef(false);
  // get the code from the URL
  const code = new URLSearchParams(window.location.search).get('code');

  // get the state from the URL
  const state = new URLSearchParams(window.location.search).get('state');

  // get the error from the URL
  const error = new URLSearchParams(window.location.search).get('error');

  // get the error_description from the URL
  const errorDescription = new URLSearchParams(window.location.search).get(
    'error_description',
  );
  const [message, setMessage] = useState(
    'Processing Zendesk Authentication...',
  );

  useEffect(() => {
    if (!org || effectRunRef.current) return; // Prevent running the effect again
    effectRunRef.current = true;
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const redirectUri = `${window.location.origin}/zendesk_oauth_redirect`; // Your actual redirect URI
      const subdomain = state?.split(':')[1];

      if (!code || !state || !subdomain) {
        console.error('Invalid state or missing code/state');
        return;
      }

      const body: {
        Code: string;
        RedirectURI: string;
        OrgId?: string;
        Subdomain: string;
      } = {
        Code: code,
        RedirectURI: redirectUri,
        Subdomain: subdomain,
      };

      if (org) {
        body.OrgId = org.id;
      }

      try {
        await __request(OpenAPI, {
          method: 'POST',
          url: `/integrations/zendesk/getAccessToken`,
          body,
          mediaType: 'application/json',
        });

        setMessage('Authentication successful, redirecting to integrations...');
        window.location.href = `/settings?activeNav=integrations`;
      } catch (error) {
        setMessage('Authentication unsuccessful, please try again!');
        window.location.href = `/settings?activeNav=integrations`;
        console.error('Error during authentication callback', error);
      }
    };

    handleCallback();
  }, [org]);

  return (
    <div>
      <p>{message}</p>
    </div>
  );
};
